<div class="ball-scale-multiple blue" [ngStyle]="{'display': ((show$ | async)) ? 'flex' : 'none'}">
  <div></div>
  <div></div>
  <div></div>
</div>
